// client-web-appsuite/src/constants/strategy.js

let STRATEGY = {
    NONE: {
        label: 'None',
        value: null
    },
    EQUAL_CONDITION: {
        label: 'Equal-weighted Condition',
        value: 'equal_weighted_condition'
    },
    CONSENSUS_CONDITION: {
        label: 'Consensus-weighted Condition',
        value: 'consensus_weighted_condition'
    },
    EQUAL_FLOW: {
        label: 'Equal-weighted Flow',
        value: 'equal_weighted_flow'
    },
    CONSENSUS_FLOW: {
        label: 'Consensus-weighted Flow',
        value: 'consensus_weighted_flow'
    },
    ADAPTIVE: {
        label: 'Adaptive-weighted Flow',
        value: 'adaptive_weighted_flow'
    }
}

STRATEGY = Object.freeze(STRATEGY)

export default STRATEGY